import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function renderContact(): string {
  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- Contact Hero Section -->
      <section style="position: relative; padding: 5rem 0 4rem; overflow: hidden; background: radial-gradient(circle at 50% 20%, rgba(102, 126, 234, 0.15) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(255, 255, 255, 0.08);">
        <div class="container" style="position: relative; z-index: 1; text-align: center; max-width: 800px;">
          <div class="badge badge-cyan" style="margin-bottom: 1rem;">
            <sl-icon name="chat-dots"></sl-icon>
            <span>Connect with AtomixM</span>
          </div>
          <h1 style="font-size: clamp(2.2rem, 5vw, 3.5rem); margin-bottom: 1.25rem;">
            Let's Build the <span class="text-gradient">Future Together</span>
          </h1>
          <p style="font-size: 1.15rem; color: #cbd5e1; line-height: 1.6;">
            Whether you want to collaborate on game engine development, AI music production, cinematic short films, or vibe coding architecture—we’d love to hear from you.
          </p>
        </div>
      </section>

      <!-- Contact Content -->
      <section class="container" style="padding: 4.5rem 1.5rem 5rem;">
        <div style="max-width: 960px; margin: 0 auto;">
          
          <!-- Division Channel Badges -->
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(210px, 1fr)); gap: 1.25rem; margin-bottom: 3.5rem;">
            <div class="glass-panel" style="padding: 1.5rem; text-align: center; border-top: 3px solid #06d6a0;">
              <sl-icon name="controller" style="font-size: 2.2rem; color: #06d6a0; margin-bottom: 0.75rem;"></sl-icon>
              <h3 style="color: #fff; font-size: 1.05rem; margin-bottom: 0.35rem;">AtomixGame</h3>
              <p style="color: #94a3b8; font-size: 0.82rem;">Engines, Steam & App Store Collabs</p>
            </div>
            
            <div class="glass-panel" style="padding: 1.5rem; text-align: center; border-top: 3px solid #a855f7;">
              <sl-icon name="music-note-beamed" style="font-size: 2.2rem; color: #a855f7; margin-bottom: 0.75rem;"></sl-icon>
              <h3 style="color: #fff; font-size: 1.05rem; margin-bottom: 0.35rem;">AtomixMusics</h3>
              <p style="color: #94a3b8; font-size: 0.82rem;">Audio Licensing & AI Pipelines</p>
            </div>
            
            <div class="glass-panel" style="padding: 1.5rem; text-align: center; border-top: 3px solid #f97316;">
              <sl-icon name="film" style="font-size: 2.2rem; color: #f97316; margin-bottom: 0.75rem;"></sl-icon>
              <h3 style="color: #fff; font-size: 1.05rem; margin-bottom: 0.35rem;">AtomixFilms</h3>
              <p style="color: #94a3b8; font-size: 0.82rem;">AI Cinema, Drama & Shorts</p>
            </div>

            <div class="glass-panel" style="padding: 1.5rem; text-align: center; border-top: 3px solid #00d2ff;">
              <sl-icon name="code-slash" style="font-size: 2.2rem; color: #00d2ff; margin-bottom: 0.75rem;"></sl-icon>
              <h3 style="color: #fff; font-size: 1.05rem; margin-bottom: 0.35rem;">AtomixDevs</h3>
              <p style="color: #94a3b8; font-size: 0.82rem;">Vibe Coding & Architecture Inquiries</p>
            </div>
          </div>

          <!-- Contact Form Panel -->
          <div class="glass-panel" style="padding: 3rem; border: 1px solid rgba(255,255,255,0.12);">
            <h2 style="color: #fff; font-size: 1.8rem; margin-bottom: 0.5rem; text-align: center;">Send Us a Message</h2>
            <p style="color: #94a3b8; text-align: center; font-size: 0.95rem; margin-bottom: 2rem;">
              Reach out directly for project partnerships, sponsorships, or developer inquiries.
            </p>
            
            <form style="display: flex; flex-direction: column; gap: 1.5rem;" onsubmit="event.preventDefault(); alert('Thank you for reaching out to AtomixM! We will be in touch shortly.');">
              <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 1.25rem;">
                <div>
                  <label style="color: #cbd5e1; display: block; margin-bottom: 0.5rem; font-weight: 500; font-size: 0.9rem;">Your Name</label>
                  <sl-input placeholder="e.g. Alex Mercer" size="large" required></sl-input>
                </div>
                <div>
                  <label style="color: #cbd5e1; display: block; margin-bottom: 0.5rem; font-weight: 500; font-size: 0.9rem;">Your Email</label>
                  <sl-input type="email" placeholder="e.g. alex@example.com" size="large" required></sl-input>
                </div>
              </div>

              <div>
                <label style="color: #cbd5e1; display: block; margin-bottom: 0.5rem; font-weight: 500; font-size: 0.9rem;">Topic / Division of Interest</label>
                <sl-input placeholder="AtomixGame / AtomixMusics / AtomixFilms / AtomixDevs / General" size="large"></sl-input>
              </div>

              <div>
                <label style="color: #cbd5e1; display: block; margin-bottom: 0.5rem; font-weight: 500; font-size: 0.9rem;">Message</label>
                <sl-textarea placeholder="Tell us about your project, idea, or inquiry..." rows="5" size="large" required></sl-textarea>
              </div>

              <div style="text-align: center; margin-top: 0.5rem;">
                <button type="submit" class="btn-cyber" style="font-size: 1.05rem; padding: 0.85rem 2.5rem; width: 100%; max-width: 320px;">
                  <sl-icon name="send"></sl-icon>
                  <span>Send Message</span>
                </button>
              </div>
            </form>
          </div>

        </div>
      </section>
    </main>
    
    ${Footer()}
  `;
}
